import { useFormikContext } from "formik";

import { chain } from "lodash";
import filter from "lodash/filter";
import includes from "lodash/includes";
import map from "lodash/map";
import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { makeGetTeammates } from "../../../../../../selectors/employer/teammateSelectors";
import DropdownSelect from "../../../../../forms/custom/DropdownSelect";
import { ACTIVE } from "../../../../../shared/Team/constants";
import {
  TEAM_MANAGER,
  FINANCE_MANAGER,
  CONTRACT_CLIENT_MANAGER,
} from "../../../../Team/constants";

const roles = [TEAM_MANAGER, FINANCE_MANAGER, CONTRACT_CLIENT_MANAGER];

function TimesheetApproversField({
  openUpwards = true,
  shouldIncludeAllTimesheetApprovers = false,
  fieldName = "contractClientIndividualIds",
}) {
  const { values, setFieldValue, touched, errors, handleBlur } =
    useFormikContext();

  const teammates = useSelector(makeGetTeammates(ACTIVE, false, true));

  const options = useMemo(
    () =>
      chain(teammates)
        .filter(
          ({ attributes }) =>
            shouldIncludeAllTimesheetApprovers ||
            attributes.roles.some((v) => roles.includes(v))
        )
        .map(({ id, attributes }) => ({
          value: id,
          label: `${attributes.name} ${attributes.registered ? "" : "(Pending)"}`,
        }))
        .value(),
    [teammates, shouldIncludeAllTimesheetApprovers]
  );

  const value = useMemo(
    () =>
      filter(options, (option) => includes(values[fieldName], option.value)),
    [values[fieldName], options, fieldName]
  );

  const handleChange = useCallback(
    (newValue) => {
      const newValues = map(newValue, "value");

      setFieldValue(fieldName, newValues);
    },
    [setFieldValue, fieldName]
  );

  const errorMessage = touched[fieldName] && errors[fieldName];

  const label = (
    <>
      Contract Managers
      <Tooltip
        id="tooltip-icon-contract-managers"
        title="Contract managers can see workers once they begin a contract and will be responsible for managing timesheets."
        placement="right"
      >
        <InfoOutlinedIcon
          style={{
            margin: "0px 0px -2px 4px",
            fontSize: 14,
          }}
        />
      </Tooltip>
    </>
  );

  return (
    <DropdownSelect
      {...{ options, value }}
      id={fieldName}
      labelText="Contract Managers"
      label={label}
      isMulti
      isClearable
      openUpwards={openUpwards}
      onChange={handleChange}
      error={Boolean(errorMessage)}
      helperText={errorMessage}
      onBlur={handleBlur}
      overrideStyles={{ menuList: { maxHeight: 250 } }}
    />
  );
}

export default TimesheetApproversField;
